/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'underscore'
], (
	_
) => {
	class LocalFilterMemberDNDHelper {
		static addOrUpdateFilter(options = {}, transactionToken) {
			const localFilters = options.localFilters;
			const localFiltersSpec = options.localFiltersSpec;
			const doUpdateFilters = _.isBoolean(options.doUpdateFilters) ? options.doUpdateFilters : true;

			if (options.bReplace && doUpdateFilters) {
				localFilters.removeFilter(options.itemContext, transactionToken);
			}

			const filterSpec = localFilters.getFilterList().find(filter => filter.columnId === options.itemContext.itemId) || {};
			const hasFilters = localFilters.filterExists(options.itemContext);
			const filterContext = LocalFilterMemberDNDHelper.getFilterContext(hasFilters, options.newLocalFilters, filterSpec);

			if (filterSpec.conditions) {
				filterSpec.conditionsInfo = {};
				filterSpec.conditionsInfo.conditions = filterSpec.conditions;
				filterSpec.conditionsInfo.excludedValues = filterSpec.excludedValues;
				delete filterSpec.conditions;
				delete filterSpec.excludedValues;
			}

			if (localFiltersSpec) {
				localFiltersSpec.push({ hasFilters: hasFilters, itemContext: options.itemContext, filterContext: filterContext });
			}

			if (doUpdateFilters) {
				if (hasFilters) {
					localFilters.editFilter(options.itemContext, filterContext, transactionToken);
				} else {
					localFilters.addFilter(options.itemContext, filterContext, transactionToken);
				}
			}

			return hasFilters;
		}

		static getItemContext(dataItemList = [], metadataColumn) {
			const columnId = metadataColumn.getId();
			const item = dataItemList.find(dataItem => dataItem.getColumnId() === columnId) || metadataColumn;
			const itemId = item.getId();

			return {
				uniqueId: itemId,
				itemId: item.getColumnId ? item.getColumnId() : itemId
			};
		}

		/**
		 * @example
		 * filterSpec = {
			* 	values: [{
			* 		u: 'dataSetDemo_csv.Product_line->[Camping Equipment]',
			* 		d: 'Camping Equipment'
			* 	}]
			* }
		*/
		static createFilterSpec(filters = [], filterSpec = {}) {

			if (filters.length > 0) {
				filterSpec.values = filterSpec.values || [];
				filterSpec.overrideHierarchyDefaultSelection = filterSpec.overrideHierarchyDefaultSelection || true;

				filters.forEach(filter=> {
					if (!LocalFilterMemberDNDHelper.filterValueExist(filterSpec.values, filter.id)) {
						filterSpec.values.push({
							u: filter.id,
							d: filter.memberCaption
						});
					}
				});
			}
			return filterSpec;
		}

		static getFilterContext(hasFilters = false, filters = [], filterSpec = {}, ) {
			let  filterContext;
			// if the local filter operator is 'notin' and member is already exclude it, we need to remove only from exclude list
			if (hasFilters && filterSpec.operator ==='notin') {
				LocalFilterMemberDNDHelper.removeFromExcludeValues(filters, filterSpec);
				filterSpec.exclude = true;
				filterContext = filterSpec;
			} else {
				filterContext = LocalFilterMemberDNDHelper.createFilterSpec(filters, filterSpec);
			}
			return filterContext;
		}

		// If member to be include is already is exclude it, need to remove the members from list of values
		static removeFromExcludeValues(filters = [], filterSpec = {}) {
			const _removeExclueValue = (values, id) => {
				if (LocalFilterMemberDNDHelper.filterValueExist(filterSpec.values, id)) {
					values.forEach((value, index) => {
						if (value.u === id) {
							values.splice(index, 1);
						}
					});
				}
			};
			if (filters.length > 0) {
				filters.forEach(filter => {
					_removeExclueValue(filterSpec.values, filter.id);
				});
			}
			return filterSpec;
		}

		static filterValueExist(values = [], useValue) {
			return !!(values.find(value => value.u === useValue));
		}

		static hasDataItem (dataItemList = [], columnId) {
			return dataItemList.find(dataItem => {
				return dataItem.getColumnId() === columnId;
			}) ? true : false;
		}
	}

	return LocalFilterMemberDNDHelper;
});
